import styled from 'styled-components';
import { s8 } from '@ardoq/design-tokens';
import { TextOverflow } from '@ardoq/popovers';

const ViewLegendItemLabel = styled(TextOverflow)`
  margin-left: ${s8};
  overflow: hidden;

  .forExport & {
    flex: 3 1 auto;
    max-height: unset;
  }
`;

export { ViewLegendItemLabel };
